import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const Breadcrumb = withRouter((props) => {
    const { navegacoes } = useAuth();
    const current = props.location.pathname;

    if (current === '/dashboard') {
        return null;
    }

    const lastRoute = current.replace(/\/((?!\/).)*$/g, '') || '/dashboard';
    const ObterTituloRota = (path) => {
        const a = navegacoes.find((el) => el.caminho === path);
        return a?.nome;
    };

    return (
        <div className="breadcrumb">
            <Link to={lastRoute}>
                <i className="icon icon-arrow-left"></i>
                {ObterTituloRota(lastRoute)}
            </Link>
        </div>
    );
});

export default Breadcrumb;
